t = require('views/internal/recup-with-helpers')('create_first_board')
l = require 'lib/localize'

module.exports = {
  BOARD_NAME: 'board-name'
  LIST_NAME: 'list-name'
  CARD_NAME: 'card-name'
  CHECKITEM_NAME: 'check-name'
  CARD_DRAG: 'card-drag'
  INITIAL_DATA: {
    name: ''
    checkItem: ''
    defaultValue: l('untitled board')
    lists: [
      {
        name: t.l('things-to-do')
        cards: [
          {
            name: ''
            large: false
            defaultValue: l('untitled card')
          }
          {
            name: ''
            large: false
          }
          {
            name: ''
            large: false
          }
        ]
      }
      {
        name: t.l('doing')
        cards: [
          {
            name: ''
            large: true
          }
          {
            name: ''
            large: false
          }
          {
            name: ''
            large: true
          }
        ]
      }
      {
        name: t.l('done')
        cards: [
          {
            name: ''
            large: false
          }
          {
            name: ''
            large: true
          }
          {
            name: ''
            large: false
          }
        ]
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./app/scripts/views/create-first-board/constants.coffee